import React from "react";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerIncludes } from "../../data/content";
const valueRows = [{
  label: "Nail Course In A Box™",
  sub: "6 Premium Volumes",
  price: "$147"
}, {
  label: "5 Exclusive Bonus Kits",
  sub: "Certificates, planner, library, templates & checklists",
  price: "$197"
}];
export function Offer() {
  return <Section id="offer" tone="blush" data-id="element-193" data-mp="3f2feeox147fd">
      <SectionHeading kicker="Special launch offer" data-id="element-194" data-mp="3juqh1zj5m7bm">Here's everything you'll receive today</SectionHeading>

      <div className="relative mt-10 overflow-hidden rounded-[28px] border-2 border-berry bg-white shadow-[0_30px_60px_-30px_rgba(163,51,90,0.6)]" data-id="element-195" data-mp="3nx3lmkm5zz6t">
        <div className="bg-berry px-4 py-3 text-center text-[13px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-196" data-mp="3stu0j4m8goqn">
          Launch price · Limited spots
        </div>

        <div className="p-5 md:p-10" data-id="element-197" data-mp="1kn1hedwvg3ju">
          <img src={images.mockup} alt="Everything included in Nail Course In A Box™" className="mx-auto w-full max-w-xl" data-id="element-198" data-mp="1fmdf2w3700ab" />

          <ul className="mt-6 divide-y divide-petal border-y border-petal" data-id="element-199" data-mp="1bka4sas9f1qm">
            {valueRows.map(r => <li key={r.label} className="flex items-center justify-between gap-4 py-4" data-id="element-200" data-mp="16mqnt346gauz">
                <div data-id="element-201" data-mp="23c7sberfbqv3">
                  <p className="text-[16px] font-bold text-ink" data-id="element-202" data-mp="23bg6gvnmp7i0">{r.label}</p>
                  <p className="text-[14px] text-muted" data-id="element-203" data-mp="1za4ggp0uek9a">{r.sub}</p>
                </div>
                <span className="text-[17px] font-bold text-muted line-through" data-id="element-204" data-mp="1uj4kpn3gm88d">{r.price}</span>
              </li>)}
            <li className="flex items-center justify-between py-4" data-id="element-205" data-mp="1pjrwaxwxwt3o">
              <p className="text-[15px] font-extrabold uppercase tracking-wider text-ink" data-id="element-206" data-mp="2n0gwkn68rnay">Total value</p>
              <span className="text-[20px] font-extrabold text-[#C0392B] line-through" data-id="element-207" data-mp="2i8ys3p50f4l8">$344</span>
            </li>
          </ul>

          <div className="mt-8 text-center" data-id="element-208" data-mp="3160pxweaqoct">
            <p className="text-[14px] font-bold uppercase tracking-[0.12em] text-muted" data-id="element-209" data-mp="364akq5w3zmxw">
              Today you get everything for only…
            </p>
            <p className="mt-2 font-serif text-[88px] font-bold leading-none text-berry md:text-[112px]" data-id="element-210" data-mp="2scnmi0ilw4ch">
              <span className="align-top text-[40px] md:text-[52px]" data-id="element-211" data-mp="2wcxtngi4x0sx">$</span>27
            </p>
            <p className="mt-2 text-[14px] font-semibold text-ink" data-id="element-212" data-mp="2idenuucsq1js">USD · One-time payment</p>
          </div>

          <ul className="mx-auto mt-6 grid max-w-md gap-2.5" data-id="element-213" data-mp="2nfdmjqxlcaae">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[16px] font-medium text-ink" data-id="element-214" data-mp="29ge3qzwrepm5">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-215" data-mp="2dhzcc929ghqj">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-216" data-mp="bojfuvjhs8nn" />
                </span>
                {item}
              </li>)}
          </ul>

          <ScarcityBar data-id="element-217" data-mp="1w4hhud71zsdc" />

          <CTAButton label="Yes — I want Nail Course In A Box™" note="Instant Access · One-Time Payment of $27 · 7-Day Guarantee" data-id="element-218" data-mp="1s58t5mqvekon" />
          <Countdown data-id="element-219" data-mp="25ygj79zaz848" />

          <p className="mt-6 flex items-start justify-center gap-2 text-center text-[14px] leading-relaxed text-muted" data-id="element-220" data-mp="215ncigk9xppi">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-berry" aria-hidden="true" data-id="element-221" data-mp="2fts0o023itfo" />
            <span data-id="element-222" data-mp="2avzwo7o6fgv4">
              Price shown in USD. <strong className="text-ink" data-id="element-223" data-mp="2auyl82390scv">Currency conversion is automatic</strong> — you'll see
              the amount in your local currency at checkout.
            </span>
          </p>
        </div>
      </div>

      <p className="mx-auto mt-8 max-w-xl text-center text-[16px] leading-relaxed text-muted" data-id="element-224" data-mp="2jwy6x7p7kkm5">
        For less than the cost of taking your team out for coffee, you'll have a complete system you can use to create
        and organize your nail classes again and again.
      </p>
    </Section>;
}